var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-button',{on:{"click":_vm.showModal}},[_vm._v("\n    Open Modal\n  ")]),_vm._v(" "),_c('b-modal',{ref:"addafact",attrs:{"hide-footer":"","title":"Add a Fact to the neverendingfacts module"}},[_c('p',[_vm._v("hi")])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-69c4ebb5","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/assets/exmaples/modal.vue
// module id = 556
// module chunks = 0